import { useMemo } from 'react';

import { useGetMeQuery } from 'generated/rbi-graphql';
import { NUM_RECENT_PURCHASED_ITEMS } from 'state/auth/hooks/use-current-user';
import { useOrderContext } from 'state/order';
import { isCartEntryInMenu } from 'utils/cart';

export const useRecentItemsAvailable = () => {
  const { data: userData } = useGetMeQuery({
    variables: {
      numUniquePurchasedItems: NUM_RECENT_PURCHASED_ITEMS,
    },
    fetchPolicy: 'cache-and-network',
  });

  const uniquePurchasedItems = userData?.me.uniquePurchasedItems;
  const hasUniquePurchasedItems = useMemo(
    () =>
      Array.isArray(uniquePurchasedItems) &&
      uniquePurchasedItems.length > 0 &&
      uniquePurchasedItems.some(isCartEntryInMenu),
    [uniquePurchasedItems]
  );
  const { isCatering } = useOrderContext();
  return !isCatering && hasUniquePurchasedItems;
};
